import React from "react";
import { Send, MessageCircle, NotebookPen } from "lucide-react";
import { UncontrolledTooltip } from "reactstrap";
import { IconButton } from "../../../ui/buttons";

const MessageTypeButtons = ({ changeReplyMessage, isReplyMessage, setReplyType, replyTypeChat, replyType }) => {
  return (
    <div className="d-flex align-items-center" style={{ gap: "5px", width: "fit-content" }}>
      <UncontrolledTooltip placement="top" target="send">
        Responder
      </UncontrolledTooltip>
      <IconButton isSelected={isReplyMessage} type="button" id="send" onClick={() => changeReplyMessage(!isReplyMessage)}>
        <Send size="22" />
      </IconButton>
      <UncontrolledTooltip placement="top" target="comment">
        Comentar
      </UncontrolledTooltip>
      <IconButton
        isSelected={replyTypeChat.COMMENT === replyType}
        type="button"
        id="comment"
        onClick={() => {
          setReplyType(replyTypeChat.COMMENT);
          changeReplyMessage(false);
        }}
      >
        <MessageCircle size="22" />
      </IconButton>
      <UncontrolledTooltip placement="top" target="note">
        Nota
      </UncontrolledTooltip>
      <IconButton
        isSelected={replyTypeChat.NOTE === replyType}
        type="button"
        id="note"
        onClick={() => {
          setReplyType(replyTypeChat.NOTE);
          changeReplyMessage(false);
        }}
      >
        <NotebookPen size="22" />
      </IconButton>
    </div>
  );
};

export default MessageTypeButtons;
